<template>
  <div class="form-nested-accordion">
    <form @submit.prevent="register" action="#" method="get">
      <div class="row">
        <div class="col-md-12">
          <div class="text-left">
            <FormHelper
              :inputVar="frmDownload.item"
              :form="frmDownload"
              :options="OptionsSelect()"
              placeholder="Selecione uma das opções"
              type="select"
              label="ISO"
            ></FormHelper>
          </div>
          <p class="text-center">
            <button aria-label="Download" id="register-iso" class="btn primary-button ">Download</button>
          </p>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import FormHelper from "../FormHelper.vue";

export default {
  name: "Download ISO",
  components: {
    FormHelper
  },  
  props: {
    msg: String
  },
  data() {
    return {
      frmDownload: {
        attemptSubmit: false,
        item: new this.formInput(false)
      }
    };
  },
  mounted(){
    jQuery("#register-iso").attr("disabled", true);
  },
  watch: {
    "frmDownload.item.value": function(v){
      var $button = jQuery("#register-iso");
      if(v !== null){
        $button.attr("disabled", false)
      }else{
        $button.attr("disabled", true)
      }
    }
  },
  methods: {
    formInput: function(required, value) {
      // Define um padrão para estrutura de cada input do formulário
      this.required = required !== undefined ? required : true;
      this.value = value !== undefined ? value : null;

      this.validation = {
        // Status verifica se o input é obrigatório e possui valor, e retorna verdadeiro ou falso
        // Para que o usuário seja barrado em caso de um submit sem dados
        status: !(this.required && this.value === ""),
        message: this.required ? "Por favor, preencha o campo acima" : ""
      };
    },
    OptionsSelect: function() {
      const options = [
        { code: "Windows_Server_2012_Foundation_R2_64Bits", label: "Windows Server 2012 Foundation R2 64Bits"  },
        { code: "SW_DVD9_Windows_Svr_Std_and_DataCtr_2012_R2_64Bit_PTBR", label: "Windows Server Std and DataCtr 2012 R2 64Bit PTBR"  },
        { code: "Windows_Server_2012_R2_Essentials_64Bits_PT-BR", label: "Windows Server 2012 R2 Essentials 64Bits PTBR"  },
      ];

      return options;
    },
    register : function(){
        
      let xhr = new XMLHttpRequest()
      xhr.open('POST', this.$apiUrl + "Cliente.svc/GetIsoLink")
      xhr.setRequestHeader('Content-type', 'application/json')
      xhr.withCredentials = true

      xhr.onload = () => {

        let json = JSON.parse(xhr.responseText);
        if(json != "ERRO" && json != "AVISO"){
          setTimeout(function () {window.open(json, '_blank');}, 800);
        }
      }

      xhr.send(JSON.stringify({
          nome: this.frmDownload.item.value.code
      }))
    }
  }
};
</script>
